module.exports = __webpack_public_path__ + "img/cnn_logo.02bc307.png";


//////////////////
// WEBPACK FOOTER
// ./assets/img/media/arabic/cnn_logo.png
// module id = ./assets/img/media/arabic/cnn_logo.png
// module chunks = 0 9 11 12